import { render, staticRenderFns } from "./UnBindPage.vue?vue&type=template&id=6e05e71e&scoped=true&"
import script from "./UnBindPage.vue?vue&type=script&lang=js&"
export * from "./UnBindPage.vue?vue&type=script&lang=js&"
import style0 from "./UnBindPage.vue?vue&type=style&index=0&id=6e05e71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05e71e",
  null
  
)

export default component.exports